module.exports = __webpack_public_path__ + "img/ปลากระพงขาว.29ff8d08.png";